import { render, staticRenderFns } from "./StatsController.vue?vue&type=template&id=738c29de"
import script from "./StatsController.vue?vue&type=script&lang=js"
export * from "./StatsController.vue?vue&type=script&lang=js"
import style0 from "./StatsController.vue?vue&type=style&index=0&id=738c29de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports